// packages import
import { Container } from "@mui/material"
// component import
import { Header } from "./Header"

export const Layout = () => (
  <>
    {/* max-width:1440px */}
    <Container maxWidth={false}>
      <Header />
    </Container>
  </>
)
